import React, { useState } from "react"
import { Carousel } from "react-bootstrap"
import img1 from "../images/defiler/1.png"
import img3 from "../images/defiler/3.jpg"
import img5 from "../images/defiler/layer5.png"
import img6 from "../images/defiler/cell.png"
import img8 from "../images/defiler/neuron.png"
import img9 from "../images/defiler/img8.png"
import img11 from "../images/defiler/11.png"
import img12 from "../images/defiler/Astrocytes.jpg"
import img13 from "../images/defiler/Glia.jpg"
import img14 from "../images/defiler/img14.jpg"
import PopImaging from "../images/defiler/PopImaging.png"
import IUEsergio from "../images/defiler/IUEsergio.jpg"

export default function CarouselPolleux() {
  const [isShown, setIsShown] = useState(false)
  const [isShown2, setIsShown2] = useState(false)
  const [isShown3, setIsShown3] = useState(false)
  const [isShown4, setIsShown4] = useState(false)
  const [isShown5, setIsShown5] = useState(false)
  const [isShown6, setIsShown6] = useState(false)
  const [isShown7, setIsShown7] = useState(false)
  const [isShown8, setIsShown8] = useState(false)
  const [isShown9, setIsShown9] = useState(false)
  const [isShown10, setIsShown10] = useState(false)
  const [isShown11, setIsShown11] = useState(false)
  const [isShown12, setIsShown12] = useState(false)
  const [isShown13, setIsShown13] = useState(false)


  return (
    <div className="carouselDiv">
      <Carousel indicators={false}>
        <Carousel.Item
          onMouseEnter={() => setIsShown(true)}
          onMouseLeave={() => setIsShown(false)}
        >
          {isShown === false && (

            <img className="imgCarousel" src={img5} alt=""/>
          )}
          {isShown === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={img5} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>Individual mouse cortical layer 5 pyramidal neuron from a Thy1-YFP line H transgenic mouse imaged by confocal microscopy. </p>
                <>Jaeda Coutinho-Budd</>
              </div>
            </>
          )}

          )}
        </Carousel.Item>

        <Carousel.Item
          onMouseEnter={() => setIsShown2(true)}
          onMouseLeave={() => setIsShown2(false)}
        >
          {isShown2 === false && (
            <img className="imgCarousel" src={img3} alt=""/>
          )}

          {isShown2 === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={img3} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>Layer 2/3 cortical pyramidal neuron electroporated ex utero to express a cell filler (mCherry- mangeta) and a presynaptic marker vGlut1-HA (green).  </p>
                <>Tommy L. Lewis</>

              </div>
            </>
          )}

        </Carousel.Item>

        <Carousel.Item
          onMouseEnter={() => setIsShown3(true)}
          onMouseLeave={() => setIsShown3(false)}
        >
          {isShown3 === false && (
            <img className="imgCarousel" src={img1} alt=""/>
          )}

          {isShown3 === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={img1} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>In utero electroporation of Cre (magenta) in CA1 Pyramidal Neurons (green) of
                  Robo2F/F mice.</p>
                <>Heike Blockus</>
              </div>
            </>
          )}
        </Carousel.Item>




        <Carousel.Item
          onMouseEnter={() => setIsShown5(true)}
          onMouseLeave={() => setIsShown5(false)}
        >
          {isShown5 === false && (
            <img className="imgCarousel" src={img6} alt=""/>
          )}

          {isShown5 === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={img6} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>In Vitro Rabv
                  Cortical neuronal culture in which presynaptic inputs (red, tdTomato) to a single cortical neuron
                  (green) were visualized using rabies virus monosynaptic tracing</p>
                <>Ewoud Schmidt</>
              </div>
            </>
          )}

        </Carousel.Item>

        <Carousel.Item
          onMouseEnter={() => setIsShown6(true)}
          onMouseLeave={() => setIsShown6(false)}
        >
          {isShown6 === false && (
            <img className="imgCarousel" src={img8} alt=""/>
          )}

          {isShown6 === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={img8} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>A cortical layer 2/3 neuron at 21 days in vitro labeled by ex utero electroporation with fluorescent
                  marker for spine visualization</p>
                <>Heike Blockus</>
              </div>
            </>
          )}


        </Carousel.Item>

        <Carousel.Item
          onMouseEnter={() => setIsShown7(true)}
          onMouseLeave={() => setIsShown7(false)}
        >
          {isShown7 === false && (
            <img className="imgCarousel" src={img9} alt=""/>
          )}

          {isShown7 === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={img9} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>Dendritic segments of mouse cortical pyramidal neuron ex utero electroporated to express tdTomato and SEP-GluA1.  </p>
                <>Kevin Gonzalez</>
              </div>
            </>
          )}


        </Carousel.Item>



        <Carousel.Item
          onMouseEnter={() => setIsShown10(true)}
          onMouseLeave={() => setIsShown10(false)}
        >
          {isShown10 === false && (
            <img className="imgCarousel" src={IUEsergio} alt=""/>
          )}

          {isShown10 === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={IUEsergio} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>In utero electroporation targeting Layer 2/3 pyramidal neurons of the somatosensory cortex with tdtomato (magenta). VGLUT2 (green) was used as a marker to visualize the Barrel Columns in the somatosensory cortex.</p>
                <>Sergio Bernal-Garcia</>
              </div>
            </>
          )}

        </Carousel.Item>

        <Carousel.Item
          onMouseEnter={() => setIsShown12(true)}
          onMouseLeave={() => setIsShown12(false)}
        >
          {isShown12 === false && (
            <img className="imgCarousel" src={img12} alt=""/>
          )}

          {isShown12 === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={img12} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>Long despised and set aside, astrocytes fulfill important functions of repair, regulation, maintenance of tissue, glutamatergic transmission, they also contact the blood capillaries with their “endfeet” </p>
                <>Eugenie PEZE-HEIDSIECK (she/her)</>
              </div>
            </>
          )}

        </Carousel.Item>

        <Carousel.Item
          onMouseEnter={() => setIsShown13(true)}
          onMouseLeave={() => setIsShown13(false)}
        >
          {isShown13 === false && (
            <img className="imgCarousel" src={img14} alt=""/>
          )}

          {isShown13 === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={img14} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>Using in utero electroporation we overexpressed in cortical pyramidal cells of layer 2/3 the human CROCC gene known to be specifically duplicated in the human lineage. In green, the protein encoded by the CROCC gene called rootlet, and in magenta the primary cilia, tiny organelles protruding from the cell surface whose functions in the adult brain are still unknown.  </p>
                <>Martina PROIETTI ONORI (she/her)</>
              </div>
            </>
          )}

        </Carousel.Item>

        <Carousel.Item
          onMouseEnter={() => setIsShown11(true)}
          onMouseLeave={() => setIsShown11(false)}
        >
          {isShown11 === false && (
            <img className="imgCarousel" src={img13} alt=""/>
          )}

          {isShown11 === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={img13} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>Glia comes from the Greek and means “glue”. Microglia come from the immune system, they hunt down and “eat” damaged neurons or fight infections. They also play a crucial role in the elimination of synapses and therefore in the communication of neurons.</p>
                <>Carlos DIAZ SALAZAR ALBELDA (he/him)</>
              </div>
            </>
          )}

        </Carousel.Item>


        <Carousel.Item
          onMouseEnter={() => setIsShown8(true)}
          onMouseLeave={() => setIsShown8(false)}
        >
          {isShown8 === false && (
            <img className="imgCarousel" src={img11} alt=""/>
          )}

          {isShown8 === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={img11} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>Contralateral callosal axons (mVenus – green) following in utero electroporation (E15 to P21). Section counterstained with Cux2 labeling layer 2-4 (red) and Hoechst (nuclei in blue). </p>
                <>Randal Hand</>
              </div>
            </>
          )}

        </Carousel.Item>

        <Carousel.Item
          onMouseEnter={() => setIsShown9(true)}
          onMouseLeave={() => setIsShown9(false)}
        >
          {isShown9 === false && (
            <img className="imgCarousel" src={PopImaging} alt=""/>
          )}

          {isShown9 === true && (
            <>
              <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={PopImaging} alt=""/>
              <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
                <p>In vivo 2-photon image of intermingled Pdzd8 WT and KO pyramidal neurons expressing calcium
                  indicator GCaMP6f in hippocampal area CA1. Knockout neurons express the red mCherry fluorescent
                  reporter</p>
                <>Justin O'Hare</>
              </div>
            </>
          )}

        </Carousel.Item>
      </Carousel>
    </div>
  )
}
//    <Carousel.Item
//           onMouseEnter={() => setIsShown4(true)}
//           onMouseLeave={() => setIsShown4(false)}
//         >
//           {isShown4 === false && (
//             <img className="imgCarousel" src={img2} alt=""/>
//           )}
//
//           {isShown4 === true && (
//             <>
//               <img className="imgCarousel" style={{ filter: "opacity(70%)" }} src={img2} alt=""/>
//               <div className="carousel-caption" style={{ color: "rgb(228, 230, 235)" }}>
//                 <p>In utero electroporation in CA1 Pyramidal Neurons.</p>
//                 <>Heike Blockus</>
//               </div>
//             </>
//           )}
//         </Carousel.Item>